module.exports = __webpack_public_path__ + "media/images/sports_coaching/card-desktop@2x-84484006a7f7bc9aecdc8900cc56d9f3.jpg";